<template>
  <b-row>
    <b-col md="5">
      <heading class="mt-2" />
    </b-col>
  </b-row>
</template>
<script>
import Heading from '../cards/Heading'

export default {
  components: {
    Heading,
  },
  props: {
    consumer: {
      type: Object,
    },
    summary: {
      type: Object,
    },
  },
}
</script>
